module.exports = __webpack_public_path__ + "static/media/specificDiseases.dcee4fee.svg";